import {
  setSelfAdjustingInterval,
  type IntervalCallback,
  type StopInterval,
} from './interval.js'

type Timer = {
  startTimer: (callback: IntervalCallback) => void
  stopTimer: () => void
}

export function createTimer(): Timer {
  let stopInterval: StopInterval | null = null

  function startTimer(callback: IntervalCallback): void {
    stopInterval = setSelfAdjustingInterval(callback, 1000)
  }

  function stopTimer(): void {
    if (stopInterval) {
      stopInterval()
    }
  }

  return {
    startTimer,
    stopTimer,
  }
}
